module.exports = __webpack_public_path__ + "img/defaultMap.38bcf335.png";